import React from 'react'

export default props => (
    <th className={props.acoes ? 'table-actions' : ''}
		style={{
			...props.style,
			textAlign: props.alignRight ? 'right' : (props.alignCenter ? 'center' : 'left'),
			width: props.width,
			height: props.height,
			paddingLeft: props.alignLeft ? 2 : 0,
			paddingRight: props.alignLeft ? 2 : 0
		}} >
		{props.children}
	</th>
)
